import React from 'react'
import Checkbox from './elements/Checkbox';
import Input from './elements/Input';
import Textarea from './elements/Textarea';
import Select from './elements/Select';
import Password from './elements/Password';
import Number from './elements/Number';
import { uuidv4 } from './Notebook/operations/notebook';
import SwitchBox from './elements/SwitchBox';

const Element = ({ field: { key, name, required, type, secret, fieldValue, placeholder } }) => {
    switch (type) {
        case "string":
            return (
                <Input
                    id={name}
                    label={name}
                    className="form-control"
                    placeholder={placeholder}
                    fieldValue={fieldValue}
                    required={required}
                />
            )
        case "integer":
            return (
                <Input
                    id={name}
                    label={name}
                    className="form-control"
                    placeholder={placeholder}
                    fieldValue={fieldValue}
                    required={required}
                />
            )
        case "json":
            return (
                <Textarea
                    id={name}
                    label={name}
                    className="form-control"
                    placeholder={placeholder}
                    fieldValue={fieldValue}
                    required={required}
                />
            )
        case 'boolean':
            return (<SwitchBox
                id={name}
                label={name}
                placeholder={placeholder}
                className="form-control"
                fieldValue={fieldValue}
                required={required}
            />)

        default:
            return null;
    }


}

export default Element